module.exports = __webpack_public_path__ + "img/banner-Top-R.9999b2af.png";